import { useDispatch } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { LoadingModal } from '../component/modal/modal';
import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchDateMonth, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum } from '../common/function';
import dayjs from 'dayjs';
import { ChevronDown } from 'lucide-react';

function SettlementAgentMobile() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);

    const [listState, setListState] = useState(false); // 테이블 리로딩 트리거

    // 로딩 모달
    const [loading, setLoading] = useState(false);

    // 'monthly' => 일별, 'yearly' => 월별
    const [period, setPeriod] = useState('monthly');

    // =========================
    // 년/월 select 동적 생성
    // =========================
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const yearList = [];
    for (let y = 2024; y <= currentYear; y++) {
        yearList.push(y);
    }
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);

    const getMonthList = () => {
        const monthArray = [];
        const limit = selectedYear === currentYear ? currentMonth : 12;
        for (let m = 1; m <= limit; m++) {
            monthArray.push(m);
        }
        return monthArray;
    };
    const monthList = getMonthList();

    // 목업데이터 (4/1 ~ 4/23)
    const mockSettlementData = [
        {
            date: '2023-04-01',
            amount: 100000,
            status: '정산완료',
            detailOpen: false,
            detailData: [
                { storeName: '가맹점A', amount: '10,000원' },
                { storeName: '가맹점B', amount: '15,000원' },
                { storeName: '가맹점C', amount: '25,000원' },
                { storeName: '가맹점D', amount: '50,000원' },
            ]
        },
        {
            date: '2023-04-02',
            amount: 120000,
            status: '정산완료',
            detailOpen: false,
            detailData: [
                { storeName: '가맹점A', amount: '20,000원' },
                { storeName: '가맹점B', amount: '10,000원' },
                { storeName: '가맹점C', amount: '30,000원' },
                { storeName: '가맹점D', amount: '60,000원' },
            ]
        },
        // ... (4/03 ~ 4/22 생략)
        {
            date: '2023-04-23',
            amount: 155000,
            status: '정산완료',
            detailOpen: false,
            detailData: [
                { storeName: '가맹점A', amount: '30,000원' },
                { storeName: '가맹점B', amount: '25,000원' },
                { storeName: '가맹점C', amount: '50,000원' },
                { storeName: '가맹점D', amount: '50,000원' },
            ]
        },
    ];

    // 실제 리스트 데이터 상태
    const [listData, setListData] = useState({
        settlement: mockSettlementData,
        totCnt: mockSettlementData.length,
    });

    // List 컴포넌트에 전달할 최종 테이블 데이터
    const [combineData, setCombineData] = useState([]);
    const [combineData1, setCombineData1] = useState([]);

    // 최초 마운트 시 헤더 / 로딩
    useEffect(() => {
        dispatch(change_Current_Location('에이전트 정산내역'));
        dispatch(changeHeaderTitle({
            mainTitle: '정산관리',
            subTitle: '에이전트 정산내역',
        }));
        setLoading(true);
        setTimeout(() => setLoading(false), 500);
    }, [dispatch]);

    // 상세 표시 토글
    const toggleDetail = (idx) => {
        setListData((prev) => {
            const newData = { ...prev };
            newData.settlement = newData.settlement.map((item, i) => {
                if (i === idx) {
                    return { ...item, detailOpen: !item.detailOpen };
                }
                return item;
            });
            return newData;
        });
    };

    // “표 안에 표” : 가맹점명 / 금액
    const renderSubTable = (detailData) => {
        return (
            <table
                style={{
                    width: '100%',
                    borderCollapse: 'collapse'
                }}
            >
                <thead style={{ background: '#f9f9f9' }}>
                    <tr>
                        <th
                            style={{
                                border: '1px solid #e7eaf3',
                                padding: '5px',
                                textAlign: 'center',
                                width: '50%',
                            }}
                        >
                            가맹점명
                        </th>
                        <th
                            style={{
                                border: '1px solid #e7eaf3',
                                padding: '5px',
                                textAlign: 'center',
                                width: '50%',
                            }}
                        >
                            정산금액
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {detailData.map((item, idx) => (
                        <tr key={idx}>
                            <td
                                style={{
                                    border: '1px solid #e7eaf3',
                                    padding: '5px',
                                    textAlign: 'center',
                                }}
                            >
                                {item.storeName}
                            </td>
                            <td
                                style={{
                                    border: '1px solid #e7eaf3',
                                    padding: '5px',
                                    textAlign: 'right',
                                }}
                            >
                                {item.amount}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    // listData => combineData 변환
    useEffect(() => {
        const tableBodyData = [];
        const tableBodyData1 = [];
        if (listData && listData.settlement) {
            listData.settlement.forEach((data, idx) => {
                // (1) 메인행
                const mainRow = [
                    {
                        no: 1,
                        text: data.date,
                        width: '80px',
                        textAlign: 'center',
                    },
                    {
                        no: 2,
                        text: `${Number(data.amount).toLocaleString()}원`,
                        width: '100px',
                        textAlign: 'right',
                    },
                    {
                        no: 3,
                        text: data.status,
                        width: '100px',
                        textAlign: 'center',
                    },
                    {
                        no: 4,
                        text: (
                            <div
                                className="pointer list-text-center"
                                style={{ color: '#0a6e0a' }}
                                onClick={() => toggleDetail(idx)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-clipboard w-4 h-4"
                                >
                                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                </svg>
                            </div>
                        ),
                        width: '50px',
                        textAlign: 'center',
                    },
                ]

                const mainRow1 = [
                    {
                        no: 1,
                        text: data.date,
                        width: '80px',
                        textAlign: 'center',
                    },
                    {
                        no: 2,
                        text: `${Number(data.amount).toLocaleString()}원`,
                        width: '100px',
                        textAlign: 'right',
                    },
                    {
                        no: 3,
                        text: data.status,
                        width: '100px',
                        textAlign: 'center',
                    },
                ];

                // 추가: 메인 행에 식별자, 열림여부
                mainRow.id = idx;
                mainRow.isOpen = data.detailOpen;

                tableBodyData.push(mainRow);


                mainRow1.id = idx;

                tableBodyData1.push(mainRow1);

                // (2) 상세가 열려 있으면 => colSpan 4
                if (data.detailOpen) {
                    tableBodyData.push([
                        {
                            no: 99,
                            colSpan: 4,
                            text: (
                                <div
                                    style={{
                                        padding: '0',
                                        margin: 0,
                                    }}
                                >
                                    {renderSubTable(data.detailData)}
                                </div>
                            ),
                        },
                    ]);
                }
            });
        }
        setCombineData(tableBodyData);
        setCombineData1(tableBodyData1);
        setListState(e => !e)
    }, [listData, period]);

    // 테이블 헤더
    const tableHeaderData = [
        { no: 1, text: '정산일', width: '80px', textAlign: 'center' },
        { no: 2, text: '정산액', width: '100px', textAlign: 'center' },
        { no: 3, text: '상태', width: '100px', textAlign: 'center' },
        { no: 4, text: '상세', width: '50px', textAlign: 'center' },
    ]

    const tableHeaderData1 = [
        { no: 1, text: '정산일', width: '80px', textAlign: 'center' },
        { no: 2, text: '정산액', width: '100px', textAlign: 'center' },
        { no: 3, text: '상태', width: '100px', textAlign: 'center' },
    ]

    return (
        <div className="content" id="contents">
            {loading && <LoadingModal />}

            {/* 검색영역 */}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <div style={{ display: 'flex', gap: '10px' }}>
                        {/* 라디오버튼: 'monthly' => 일별, 'yearly' => 월별 */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label
                                    style={{
                                        marginRight: 5,
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <input
                                        type="radio"
                                        value="monthly"
                                        checked={period === 'monthly'}
                                        onChange={(e) => {
                                            setPeriod(e.target.value);
                                        }}
                                    />
                                    <span style={{ marginLeft: 3, paddingTop: 1 }}>
                                        월별
                                    </span>
                                </label>

                                <label
                                    style={{
                                        marginRight: 5,
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <input
                                        type="radio"
                                        value="yearly"
                                        checked={period === 'yearly'}
                                        onChange={(e) => {
                                            setPeriod(e.target.value);
                                        }}
                                    />
                                    <span style={{ marginLeft: 3, paddingTop: 1 }}>
                                        연도별
                                    </span>
                                </label>
                            </div>

                            {/* 년도 + 월 셀렉트 */}
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                }}
                            >
                                <select
                                    id="check_gubun"
                                    name="check_gubun"
                                    className="form-select"
                                    aria-label="Default select example"
                                    style={{
                                        height: '30px',
                                        padding: '0 10px',
                                        fontSize: '12px',
                                        width: '70px',
                                    }}
                                    value={selectedYear}
                                    onChange={(e) => {
                                        const newYear = parseInt(e.target.value, 10);
                                        setSelectedYear(newYear);
                                        if (newYear < currentYear && selectedMonth > 12) {
                                            setSelectedMonth(12);
                                        }
                                    }}
                                >
                                    {yearList
                                        .slice()
                                        .reverse()
                                        .map((y) => (
                                            <option key={y} value={y}>
                                                {String(y).substring(2)}년
                                            </option>
                                        ))}
                                </select>

                                {period === 'monthly' && (
                                    <select
                                        id="check_gubun"
                                        name="check_gubun"
                                        className="form-select"
                                        aria-label="Default select example"
                                        style={{
                                            height: '30px',
                                            padding: '0 10px',
                                            fontSize: '12px',
                                            width: '70px',
                                        }}
                                        value={selectedMonth}
                                        onChange={(e) => {
                                            setSelectedMonth(parseInt(e.target.value, 10));
                                        }}
                                    >
                                        {monthList
                                            .slice()
                                            .reverse()
                                            .map((m) => (
                                                <option key={m} value={m}>
                                                    {m}월
                                                </option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            {/* 테이블 영역 */}
            <div className="intro-y box intro-padding">
                <div style={{ maxWidth: '360px', width: "100%" }}>
                    {
                        period === 'monthly'
                            ?
                            <List
                                tableHeaderData={tableHeaderData}
                                tableBodyData={listData.totCnt} // 전체 건수
                                filter_tableBodyData={combineData}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                nonePage={true}
                            />
                            :
                            <List1
                                tableHeaderData={tableHeaderData1}
                                tableBodyData={listData.totCnt} // 전체 건수
                                filter_tableBodyData={combineData1}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                nonePage={true}
                            />
                    }
                </div>
            </div>
        </div>
    );
}

function List({
    tableHeaderData,
    tableBodyData,
    filter_tableBodyData = [],
    page,
    setPage,
    maxFirstPage,
    onInputChange,
    height,
    nonePage = true,

    // 체크박스 관련
    checkedRows = [],
    onCheckboxChange = () => { },

    clickData,
    onRowClick,
    listType = false,
    listState = false,
    scrollState = false,
}) {
    const widthRef = useRef();
    const [Width, setWidth] = useState('0');
    const [tableWidth, setTableWidth] = useState('0');
    const [extraWidth, setExtraWidth] = useState(0);

    // 스크롤 여부
    const [isScrollable, setIsScrollable] = useState(false);
    const [atBottom, setAtBottom] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (widthRef.current) {
                setWidth(`${widthRef.current.offsetWidth}`);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // 테이블 폭 계산
    useEffect(() => {
        if (Width !== '0' && tableWidth !== '0' && !isNaN(Width) && !isNaN(tableWidth)) {
            if (Number(Width) > Number(tableWidth)) {
                setExtraWidth((Number(Width) - Number(tableWidth)) / tableHeaderData.length);
            } else {
                setExtraWidth(0);
            }
        }
    }, [Width, tableWidth, tableHeaderData]);

    // 스크롤 가능한지 여부
    useEffect(() => {
        if (widthRef.current) {
            const el = widthRef.current;
            if (el.scrollHeight > el.clientHeight) {
                setIsScrollable(true);
            } else {
                setIsScrollable(false);
            }
        }
    }, [filter_tableBodyData, tableBodyData]);

    // 맨 아래 스크롤 이벤트
    useEffect(() => {
        const el = widthRef.current;
        if (!el) return;
        const handleScroll = () => {
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1) {
                setAtBottom(true);
            } else {
                setAtBottom(false);
            }
        };
        el.addEventListener('scroll', handleScroll);
        return () => el.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="overflow-x-auto scrollbar-hidden relative">
            <div
                id="tabulator2"
                className="mt-3 table-report table-report--tabulator payList tabulator"
                role="grid"
                tabulator-layout="fitColumns"
                style={{ height: height ? height : '' }}
            >
                <div className="tabulator-tableHolder relative" ref={widthRef}>
                    <Listheader
                        tableHeaderData={tableHeaderData}
                        Width={Width}
                        extraWidth={extraWidth}
                        tableWidth={tableWidth}
                        setTableWidth={setTableWidth}
                    />
                    <Listbody
                        filter_tableBodyData={filter_tableBodyData}
                        extraWidth={extraWidth}
                        onInputChange={onInputChange}
                        // 체크박스
                        checkedRows={checkedRows}
                        onCheckboxChange={onCheckboxChange}
                        selectedData={clickData}
                        onRowClick={onRowClick}
                    />
                </div>

                {isScrollable && !atBottom && scrollState && (
                    <div
                        className="absolute left-1/2 transform -translate-x-1/2 flex flex-col items-center"
                        style={{ bottom: '30px' }}
                    >
                        <ChevronDown size={30} />
                    </div>
                )}
            </div>
        </div>
    );
}

function Listheader({ tableHeaderData, Width, extraWidth, tableWidth, setTableWidth }) {
    const ref = useRef();

    useEffect(() => {
        if (ref.current) {
            setTableWidth(`${ref.current.offsetWidth}` ?? '100%');
        }
    }, [setTableWidth]);

    const containerWidth = Number(Width) > Number(tableWidth) ? Width : tableWidth;

    return (
        <div
            className="tabulator-header"
            tabIndex="0"
            style={{
                paddingRight: '0px',
                marginLeft: '0px',
                width: `${containerWidth}px`,
            }}
        >
            <div
                className="tabulator-headers tabulator-table"
                style={{ marginLeft: '0px' }}
                ref={ref}
            >
                {tableHeaderData.map((a, i) => (
                    <TableHeaderList key={i} item={a} extraWidth={extraWidth} />
                ))}
            </div>
        </div>
    );
}

function TableHeaderList({ item, extraWidth }) {
    let wid = item?.width?.split('px');
    const calcWidth = wid?.[0] ? Number(wid[0]) + extraWidth : 100;

    return (
        <div
            className="tabulator-col tabulator-sortable"
            role="columnheader"
            aria-sort="none"
            style={{
                minWidth: calcWidth + 'px',
                width: calcWidth + 'px',
            }}
        >
            <div className="tabulator-col-content">
                <div className="tabulator-col-title-holder">
                    <div
                        className="tabulator-col-title"
                        style={{ textAlign: item?.textAlign ?? 'center' }}
                    >
                        {item?.text ?? ''}
                    </div>
                    <div className="tabulator-col-sorter">
                        <div className="tabulator-arrow"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Listbody({
    filter_tableBodyData = [],
    extraWidth,
    onInputChange,
    // 체크박스
    checkedRows,
    onCheckboxChange,
    selectedData,
    onRowClick,
}) {
    if (!filter_tableBodyData.length) {
        return (
            <div
                tabIndex="0"
                style={{
                    minHeight: 'calc(100% - 84px)',
                    height: 'auto',
                    maxHeight: 'calc(100% - 84px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        color: '#666',
                        margin: '70px 0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        flexDirection: 'column',
                    }}
                >
                    <p>리스트가 없습니다.</p>
                </div>
            </div>
        );
    }

    return (
        <div
            tabIndex="0"
            style={{
                minHeight: 'calc(100% - 84px)',
                height: 'auto',
                maxHeight: 'calc(100% - 84px)',
            }}
        >
            <div
                className="tabulator-table"
                style={{ paddingTop: '0px', paddingBottom: '0px' }}
            >
                {filter_tableBodyData.map((rowArr, rowIndex) => {
                    // (A) 상세행(colSpan)
                    if (rowArr.length === 1 && rowArr[0].colSpan) {
                        return (
                            <div
                                key={rowIndex}
                                className="tabulator-row tabulator-selectable tabulator-row-odd"
                                role="row"
                            >
                                <div
                                    className="tabulator-cell table-overflow-hidden no-padding"
                                    role="gridcell"
                                    style={{
                                        width: '100%',
                                        textAlign: 'center',
                                        height: 'auto',
                                        border: 'none',
                                    }}
                                >
                                    {rowArr[0].text}
                                </div>
                            </div>
                        );
                    }

                    // (B) 일반행
                    let rowStyle = {};
                    let rowClass = 'tabulator-row tabulator-selectable tabulator-row-odd';

                    // “isOpen” true인 경우 배경색
                    if (rowArr.isOpen) {
                        rowStyle.backgroundColor = '#fff4ce';
                    }

                    return (
                        <div
                            key={rowIndex}
                            className={rowClass}
                            role="row"
                            style={{
                                paddingLeft: '0px',
                                cursor: onRowClick ? 'pointer' : 'default',
                                ...rowStyle,
                            }}
                            onClick={() => onRowClick?.(rowArr)}
                        >
                            {rowArr.map((item, cellIndex) => (
                                <TableBodyList
                                    key={cellIndex}
                                    item={item}
                                    extraWidth={extraWidth}
                                    rowIndex={rowIndex}
                                    cellIndex={cellIndex}
                                    onInputChange={onInputChange}
                                    checkedRows={checkedRows}
                                    onCheckboxChange={onCheckboxChange}
                                />
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function TableBodyList({
    item,
    extraWidth,
    rowIndex,
    cellIndex,
    onInputChange,
    // 체크박스
    checkedRows,
    onCheckboxChange,
}) {
    const [isEditing, setIsEditing] = useState(false);
    const [isComposing, setIsComposing] = useState(false);

    let wid = item?.width?.split('px');
    const calcWidth = wid?.[0] ? Number(wid[0]) + extraWidth : 100;

    const commonStyle = {
        width: calcWidth + 'px',
        textAlign: item?.textAlign ?? 'center',
        display: 'inline-flex',
        alignItems: 'flex-start',
        justifyContent:
            item.textAlign === 'left'
                ? 'flex-start'
                : item.textAlign === 'center'
                    ? 'center'
                    : item.textAlign === 'right'
                        ? 'flex-end'
                        : 'center',
        height: '36px',
    };

    // 체크박스 열
    if (item.type === 'checkbox') {
        const isChecked = checkedRows.includes(rowIndex);
        return (
            <div
                className="tabulator-cell table-overflow-hidden"
                role="gridcell"
                style={{ ...commonStyle, justifyContent: 'center' }}
            >
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => onCheckboxChange(rowIndex, e.target.checked)}
                    style={{ border: '1px solid #afafaf' }}
                />
            </div>
        );
    }

    // 편집 가능한 열
    const handleDoubleClick = () => {
        if (item.type === 'editable') {
            setIsEditing(true);
        }
    };
    const handleChange = (e) => {
        if (isComposing) return;
        onInputChange?.(rowIndex, cellIndex, e.target.value);
    };

    if (item.type === 'editable') {
        if (!isEditing) {
            return (
                <div
                    className="tabulator-cell table-overflow-hidden"
                    role="gridcell"
                    style={commonStyle}
                    onDoubleClick={handleDoubleClick}
                >
                    {typeof item?.text === 'string' ? item.text : item.text ?? ''}
                </div>
            );
        } else {
            return (
                <input
                    className="tabulator-cell table-overflow-hidden"
                    role="gridcell"
                    style={{ ...commonStyle, backgroundColor: 'yellow' }}
                    value={typeof item?.text === 'string' ? item.text : ''}
                    onChange={handleChange}
                    onCompositionStart={() => setIsComposing(true)}
                    onCompositionEnd={(e) => {
                        setIsComposing(false);
                        onInputChange?.(rowIndex, cellIndex, e.target.value);
                    }}
                />
            );
        }
    }

    // 일반 텍스트 열
    return (
        <div
            className="tabulator-cell table-overflow-hidden"
            role="gridcell"
            style={commonStyle}
            onDoubleClick={handleDoubleClick}
        >
            {typeof item?.text === 'string' ? item.text : item.text ?? ''}
        </div>
    );
}

function List1({
    tableHeaderData,
    tableBodyData,
    filter_tableBodyData = [],
    page,
    setPage,
    maxFirstPage,
    onInputChange,
    height,
    nonePage = true,

    // 체크박스 관련
    checkedRows = [],
    onCheckboxChange = () => { },

    clickData,
    onRowClick,
    listType = false,
    listState = false,
    scrollState = false,
}) {
    const widthRef = useRef();
    const [Width, setWidth] = useState('0');
    const [tableWidth, setTableWidth] = useState('0');
    const [extraWidth, setExtraWidth] = useState(0);

    // 스크롤 여부
    const [isScrollable, setIsScrollable] = useState(false);
    const [atBottom, setAtBottom] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (widthRef.current) {
                setWidth(`${widthRef.current.offsetWidth}`);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // 테이블 폭 계산
    useEffect(() => {
        if (Width !== '0' && tableWidth !== '0' && !isNaN(Width) && !isNaN(tableWidth)) {
            if (Number(Width) > Number(tableWidth)) {
                setExtraWidth((Number(Width) - Number(tableWidth)) / tableHeaderData.length);
            } else {
                setExtraWidth(0);
            }
        }
    }, [Width, tableWidth, tableHeaderData]);

    // 스크롤 가능한지 여부
    useEffect(() => {
        if (widthRef.current) {
            const el = widthRef.current;
            if (el.scrollHeight > el.clientHeight) {
                setIsScrollable(true);
            } else {
                setIsScrollable(false);
            }
        }
    }, [filter_tableBodyData, tableBodyData]);

    // 맨 아래 스크롤 이벤트
    useEffect(() => {
        const el = widthRef.current;
        if (!el) return;
        const handleScroll = () => {
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1) {
                setAtBottom(true);
            } else {
                setAtBottom(false);
            }
        };
        el.addEventListener('scroll', handleScroll);
        return () => el.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="overflow-x-auto scrollbar-hidden relative">
            <div
                id="tabulator2"
                className="mt-3 table-report table-report--tabulator payList tabulator"
                role="grid"
                tabulator-layout="fitColumns"
                style={{ height: height ? height : '' }}
            >
                <div className="tabulator-tableHolder relative" ref={widthRef}>
                    <Listheader1
                        tableHeaderData={tableHeaderData}
                        Width={Width}
                        extraWidth={extraWidth}
                        tableWidth={tableWidth}
                        setTableWidth={setTableWidth}
                    />
                    <Listbody1
                        filter_tableBodyData={filter_tableBodyData}
                        extraWidth={extraWidth}
                        onInputChange={onInputChange}
                        // 체크박스
                        checkedRows={checkedRows}
                        onCheckboxChange={onCheckboxChange}
                        selectedData={clickData}
                        onRowClick={onRowClick}
                    />
                </div>

                {isScrollable && !atBottom && scrollState && (
                    <div
                        className="absolute left-1/2 transform -translate-x-1/2 flex flex-col items-center"
                        style={{ bottom: '30px' }}
                    >
                        <ChevronDown size={30} />
                    </div>
                )}
            </div>
        </div>
    );
}

function Listheader1({ tableHeaderData, Width, extraWidth, tableWidth, setTableWidth }) {
    const ref = useRef();

    useEffect(() => {
        if (ref.current) {
            setTableWidth(`${ref.current.offsetWidth}` ?? '100%');
        }
    }, [setTableWidth]);

    const containerWidth = Number(Width) > Number(tableWidth) ? Width : tableWidth;

    return (
        <div
            className="tabulator-header"
            tabIndex="0"
            style={{
                paddingRight: '0px',
                marginLeft: '0px',
                width: `${containerWidth}px`,
            }}
        >
            <div
                className="tabulator-headers tabulator-table"
                style={{ marginLeft: '0px' }}
                ref={ref}
            >
                {tableHeaderData.map((a, i) => (
                    <TableHeaderList1 key={i} item={a} extraWidth={extraWidth} />
                ))}
            </div>
        </div>
    );
}

function TableHeaderList1({ item, extraWidth }) {
    let wid = item?.width?.split('px');
    const calcWidth = wid?.[0] ? Number(wid[0]) + extraWidth : 100;

    return (
        <div
            className="tabulator-col tabulator-sortable"
            role="columnheader"
            aria-sort="none"
            style={{
                minWidth: calcWidth + 'px',
                width: calcWidth + 'px',
            }}
        >
            <div className="tabulator-col-content">
                <div className="tabulator-col-title-holder">
                    <div
                        className="tabulator-col-title"
                        style={{ textAlign: item?.textAlign ?? 'center' }}
                    >
                        {item?.text ?? ''}
                    </div>
                    <div className="tabulator-col-sorter">
                        <div className="tabulator-arrow"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Listbody1({
    filter_tableBodyData = [],
    extraWidth,
    onInputChange,
    // 체크박스
    checkedRows,
    onCheckboxChange,
    selectedData,
    onRowClick,
}) {
    if (!filter_tableBodyData.length) {
        return (
            <div
                tabIndex="0"
                style={{
                    minHeight: 'calc(100% - 84px)',
                    height: 'auto',
                    maxHeight: 'calc(100% - 84px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        color: '#666',
                        margin: '70px 0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        flexDirection: 'column',
                    }}
                >
                    <p>리스트가 없습니다.</p>
                </div>
            </div>
        );
    }

    return (
        <div
            tabIndex="0"
            style={{
                minHeight: 'calc(100% - 84px)',
                height: 'auto',
                maxHeight: 'calc(100% - 84px)',
            }}
        >
            <div
                className="tabulator-table"
                style={{ paddingTop: '0px', paddingBottom: '0px' }}
            >
                {filter_tableBodyData.map((rowArr, rowIndex) => {
                    // (A) 상세행(colSpan)
                    if (rowArr.length === 1 && rowArr[0].colSpan) {
                        return (
                            <div
                                key={rowIndex}
                                className="tabulator-row tabulator-selectable tabulator-row-odd"
                                role="row"
                            >
                                <div
                                    className="tabulator-cell table-overflow-hidden no-padding"
                                    role="gridcell"
                                    style={{
                                        width: '100%',
                                        textAlign: 'center',
                                        height: 'auto',
                                        border: 'none',
                                    }}
                                >
                                    {rowArr[0].text}
                                </div>
                            </div>
                        );
                    }

                    // (B) 일반행
                    let rowStyle = {};
                    let rowClass = 'tabulator-row tabulator-selectable tabulator-row-odd';

                    // “isOpen” true인 경우 배경색
                    if (rowArr.isOpen) {
                        rowStyle.backgroundColor = '#fff4ce';
                    }

                    return (
                        <div
                            key={rowIndex}
                            className={rowClass}
                            role="row"
                            style={{
                                paddingLeft: '0px',
                                cursor: onRowClick ? 'pointer' : 'default',
                                ...rowStyle,
                            }}
                            onClick={() => onRowClick?.(rowArr)}
                        >
                            {rowArr.map((item, cellIndex) => (
                                <TableBodyList1
                                    key={cellIndex}
                                    item={item}
                                    extraWidth={extraWidth}
                                    rowIndex={rowIndex}
                                    cellIndex={cellIndex}
                                    onInputChange={onInputChange}
                                    checkedRows={checkedRows}
                                    onCheckboxChange={onCheckboxChange}
                                />
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function TableBodyList1({
    item,
    extraWidth,
    rowIndex,
    cellIndex,
    onInputChange,
    // 체크박스
    checkedRows,
    onCheckboxChange,
}) {
    const [isEditing, setIsEditing] = useState(false);
    const [isComposing, setIsComposing] = useState(false);

    let wid = item?.width?.split('px');
    const calcWidth = wid?.[0] ? Number(wid[0]) + extraWidth : 100;

    const commonStyle = {
        width: calcWidth + 'px',
        textAlign: item?.textAlign ?? 'center',
        display: 'inline-flex',
        alignItems: 'flex-start',
        justifyContent:
            item.textAlign === 'left'
                ? 'flex-start'
                : item.textAlign === 'center'
                    ? 'center'
                    : item.textAlign === 'right'
                        ? 'flex-end'
                        : 'center',
        height: '36px',
    };

    // 체크박스 열
    if (item.type === 'checkbox') {
        const isChecked = checkedRows.includes(rowIndex);
        return (
            <div
                className="tabulator-cell table-overflow-hidden"
                role="gridcell"
                style={{ ...commonStyle, justifyContent: 'center' }}
            >
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => onCheckboxChange(rowIndex, e.target.checked)}
                    style={{ border: '1px solid #afafaf' }}
                />
            </div>
        );
    }

    // 편집 가능한 열
    const handleDoubleClick = () => {
        if (item.type === 'editable') {
            setIsEditing(true);
        }
    };
    const handleChange = (e) => {
        if (isComposing) return;
        onInputChange?.(rowIndex, cellIndex, e.target.value);
    };

    if (item.type === 'editable') {
        if (!isEditing) {
            return (
                <div
                    className="tabulator-cell table-overflow-hidden"
                    role="gridcell"
                    style={commonStyle}
                    onDoubleClick={handleDoubleClick}
                >
                    {typeof item?.text === 'string' ? item.text : item.text ?? ''}
                </div>
            );
        } else {
            return (
                <input
                    className="tabulator-cell table-overflow-hidden"
                    role="gridcell"
                    style={{ ...commonStyle, backgroundColor: 'yellow' }}
                    value={typeof item?.text === 'string' ? item.text : ''}
                    onChange={handleChange}
                    onCompositionStart={() => setIsComposing(true)}
                    onCompositionEnd={(e) => {
                        setIsComposing(false);
                        onInputChange?.(rowIndex, cellIndex, e.target.value);
                    }}
                />
            );
        }
    }

    // 일반 텍스트 열
    return (
        <div
            className="tabulator-cell table-overflow-hidden"
            role="gridcell"
            style={commonStyle}
            onDoubleClick={handleDoubleClick}
        >
            {typeof item?.text === 'string' ? item.text : item.text ?? ''}
        </div>
    );
}

export default SettlementAgentMobile